import { eventBus } from 'EventBus/';
import { pushEvent } from '../../utils/datalayer';

const NAVIGATION = '.vch-header-nav';
const NAV_PANELS = '.vch-header-nav__category-panel';

const BURGER_BTN = 'NavBurger';
const STORE_LOCATOR_BTN = 'NavStoreLocator';
const MY_ACCOUNT_BTN = 'NavMyAccount';
const SEARCH_BTN_DIV = 'NavSearchBtn';
const SEARCH_BTN = 'NavSearch';

const NAV_BUTTONS = 'button.vch-header-nav__nav-button';
const PANEL_CATEGORY = '--category';
const PANEL_SUBCATEGORY = '--sub-category';
const SEARCH_PANEL = '.vch-header-search';
const SEARCH_INPUT = '#nav-search-query';

const ARIA_EXPANDED = 'aria-expanded';
const ARIA_HIDDEN = 'aria-hidden';

const OPEN_NAV = 'headernav::openNav';
const TOGGLE_PANEL = 'headernav::togglePanel';
const TOGGLE_SEARCH = 'headernav::toggleSearch';

const SEARCH_ICON_HREF = '/assets/sprite/icons.svg#search';
const CLOSE_ICON_HREF = '/assets/sprite/icons.svg#close-overlay';

const OPEN = '--open';
const CLOSING = '--closing';
const ACTIVE = '--active';
const BODY = 'body';
const ACTIVEL1 = 'active-one';
const DEFAULT_SEARCH_OPEN_LABEL = 'Search';
const DEFAULT_SEARCH_CLOSED_LABEL = 'Close (X)';

const tabletMediaQuery = '(min-width: 1201px)';

window.onload = () => {
  //Select all sub-category buttons
  const subCategoryButtons = document.querySelectorAll('.vch-header-nav__nav-button.--sub-category');
  const element = document.querySelector('.vch-category-header--concern span');
  if (!window.matchMedia(tabletMediaQuery).matches) {
    subCategoryButtons.forEach(button => {
      button.addEventListener('click', function (event) {
        // Find the parent <li> element
        const parentLi = button.closest('li');
        if (parentLi) {
          if (parentLi.classList.contains('active-second')) {
            // Add class to the clicked <li>
            document.querySelector('.active-second .vch-header-nav__category-panel')?.classList.remove(ACTIVE);            
            parentLi.classList.remove('active-second');
          } 
          else {
            // Remove 'active' class from all sibling <li> elements
            const allSiblingLis = parentLi.parentElement.querySelectorAll('li');
            allSiblingLis.forEach(li => {
              document.querySelector('.active-second .vch-header-nav__category-panel')?.classList.remove(ACTIVE);
              li.classList.remove('active-second')
            });
  
            // Add class to the clicked <li>
            parentLi.classList.add('active-second');
            document.querySelector('.active-second .vch-header-nav__category-panel')?.classList.add(ACTIVE);
          }
        }
      });
    });
  } else {
    truncateText('#NavStoreLocator');
    truncateText('#NavNewsLetter');
    truncateText('#MyAccountProfile');
    subCategoryButtons?.forEach(button => {
       button.tabIndex = -1;
    });
    keySubmenuClose();
  }
  if (element) {
    updateFontSize(element);
  }
  const els = document.querySelectorAll('.native--push-btn');      
  if (els.length > 0) {
    els.forEach(el => {
      el.addEventListener('click', () => {
        const data = el.getAttribute('data-tagging');
        const dataObj = typeof data === 'string' ? JSON.parse(data) : data;
        const sendData = {
          ...dataObj,
          eventCategory : window.wsf.pageCategory            
        };
        window.dataLayer.push(sendData);
      });
    });
  }
};

function updateFontSize(el) {
  if (!el) return;

  const length = el.textContent.trim().length;
  const fontSize = length > 13 ? 34 : 48;
  el.style.fontSize = `${fontSize}px`;
}

function truncateText(selector, maxLength = 30) {
  const element = document.querySelector(selector + ' span');
  if (element) {
    const text = element.innerHTML;
    element.innerHTML = text.slice(0, maxLength);
  }
}

const emitEvent = (type, index = null) => {
  eventBus.$emit(type, index);
};

const openMenu = (fromBurger = false) => {
  // Close Search Menu if it's open
  if (document.querySelector(SEARCH_PANEL)?.classList.contains(OPEN)) {
    toggleSearchClosed();
  }
  if (document.querySelector(NAVIGATION)?.classList.contains(OPEN)) {
    return;
  }
  document.querySelector(BODY)?.classList.add('navOpen');
  if (fromBurger) {
    document.querySelector(NAVIGATION)?.classList.add(OPEN, ACTIVE);
  } else {
    document.querySelector(NAVIGATION)?.classList.add(OPEN);
  }
  document.getElementById(BURGER_BTN)?.setAttribute(ARIA_EXPANDED, true);
 
  document.querySelector('main')?.setAttribute(ARIA_HIDDEN, true);
  document.querySelector('footer')?.setAttribute(ARIA_HIDDEN, true);
  emitEvent(OPEN_NAV, { status: true, fromBurger });
};

const deactivatePanels = (subcatOnly = false) => {
  const deactivateElement = (el) => {
    if (el.tagName === 'BUTTON') {
      el?.setAttribute(ARIA_EXPANDED, false);
    } else {
      document.querySelector('.active-second')?.classList.remove('active-second');
      el?.classList.remove(ACTIVE);
      el?.parentElement.classList.remove(ACTIVEL1);
    }
  };

  if (!subcatOnly) {
    const catEls = document.querySelectorAll(`.${PANEL_CATEGORY}`);
    catEls.forEach(deactivateElement);
  }

  const subCatEls = document.querySelectorAll(`.${PANEL_SUBCATEGORY}`);
  subCatEls.forEach(deactivateElement);
};

const closeMenu = () => {
  // Menu is already open
  document.querySelector(BODY)?.classList.remove('navOpen');
  // Mobile gets a timeout for it to slide shut before deactivating the content
  const closeTimeout = window.matchMedia(tabletMediaQuery).matches ? 0 : 300;
  document.querySelector(NAVIGATION)?.classList.remove(OPEN);
  document.querySelector(NAVIGATION)?.classList.add(CLOSING);
  document.getElementById(BURGER_BTN)?.setAttribute(ARIA_EXPANDED, false);
  setTimeout(() => {
    document.querySelector(NAVIGATION)?.classList.remove(ACTIVE);
    document.querySelector('.vch-header-nav__nav-list .active-one')?.classList.remove(ACTIVEL1);
    document.querySelector(NAVIGATION)?.classList.remove(CLOSING);
    // Remove Open/Current Modifiers
    const panels = document.querySelectorAll(NAV_PANELS);
    panels.forEach((p) => p?.classList.remove(ACTIVE));

    const navButtons = document.querySelectorAll(NAV_BUTTONS);
    navButtons.forEach((b) => b?.setAttribute(ARIA_EXPANDED, false));

    document.querySelector('main')?.removeAttribute(ARIA_HIDDEN);
    document.querySelector('footer')?.removeAttribute(ARIA_HIDDEN);
    emitEvent(OPEN_NAV, { status: false, fromBurger: false });
  }, closeTimeout);
};

const togglePanelClosed = (trigger, target) => {
  if (target && document.querySelector(`#${target}.${ACTIVE}`)) {
    document.querySelector(`#${target}`)?.classList.remove(ACTIVE);
    document.querySelector(`#${target}`)?.parentElement.classList.remove(ACTIVEL1);
    trigger?.setAttribute(ARIA_EXPANDED, false);
    emitEvent(TOGGLE_PANEL, target);
  }
};

const togglePanelOpen = (trigger, target) => {
  // No need to call focus event
  //trigger.focus();
  if (target && !document.querySelector(`#${target}.${ACTIVE}`)) {
    openMenu();

    // Deactivate sibling panels
    if (trigger?.classList.contains(PANEL_CATEGORY)) {
      deactivatePanels(false);
    }
    if (trigger?.classList.contains(PANEL_SUBCATEGORY)) {
      deactivatePanels(true);
    }

    document.querySelector(`#${target}`)?.classList.add(ACTIVE);
    document.querySelector(`#${target}`)?.parentElement.classList.add(ACTIVEL1);
    if (window.matchMedia(tabletMediaQuery).matches) {
      const panels = document.querySelectorAll('.vch-header-nav__category-panel.--category.--active .vch-header-nav__category-panel.--sub-category');
      panels.forEach((p) => p?.classList.add(ACTIVE));
    }
    trigger?.setAttribute(ARIA_EXPANDED, true);
    emitEvent(TOGGLE_PANEL, target);
    
  } else {
    if (!window.matchMedia(tabletMediaQuery).matches) {
      togglePanelClosed(trigger, target);
    }
  }
};

const toggleSearchClosed = () => {
  const searchButton = document.getElementById(SEARCH_BTN);
  searchButton?.setAttribute(ARIA_EXPANDED, false);
  searchButton?.querySelector('svg>use').setAttribute('href', SEARCH_ICON_HREF);

  const openLabel =
    searchButton.getAttribute('data-open-label') || DEFAULT_SEARCH_OPEN_LABEL;
  searchButton?.querySelector('svg')?.setAttribute('aria-label', openLabel);

  document.getElementById(STORE_LOCATOR_BTN)?.removeAttribute('tabindex');
  document.getElementById(MY_ACCOUNT_BTN)?.removeAttribute('tabindex');
  document.querySelector(SEARCH_PANEL)?.classList.remove(OPEN);
  const searchButtonDiv = document.getElementById(SEARCH_BTN_DIV);
  searchButtonDiv?.classList.remove(OPEN);
  emitEvent(TOGGLE_SEARCH, { status: false });
};

const toggleSearchPanel = () => {
  const searchPanel = document.querySelector(SEARCH_PANEL);
  const searchInput = document.querySelector(SEARCH_INPUT);
  if (searchInput) searchInput.value = '';
  if (!searchPanel?.classList.contains(OPEN)) {
    // Check if nav is open, and close it if needed
    if (document.querySelector(NAVIGATION)?.classList.contains(OPEN)) {
      closeMenu();
    }
    // Open Search Panel
    const searchButtonDiv = document.getElementById(SEARCH_BTN_DIV);
    const searchButton = document.getElementById(SEARCH_BTN);
    searchButton?.setAttribute(ARIA_EXPANDED, true);
    const closeLabel =
      searchButton.getAttribute('data-close-label') ||
      DEFAULT_SEARCH_CLOSED_LABEL;
    searchButton?.querySelector('svg')?.setAttribute('aria-label', closeLabel);
    searchButton
      ?.querySelector('svg>use')
      .setAttribute('href', CLOSE_ICON_HREF);

    document.getElementById(STORE_LOCATOR_BTN)?.setAttribute('tabindex', '-1');
    document.getElementById(MY_ACCOUNT_BTN)?.setAttribute('tabindex', '-1');

    pushEvent({
      event: 'uaevent',
      eventCategory: 'main menu navigation',
      eventAction: 'select::header',
      eventLabel: 'search',
      event_name: 'internal_search_click',
      click_area: 'header',
    });

    searchButtonDiv?.classList.add(OPEN);
    searchPanel?.classList.add(OPEN);
    searchInput.focus();
    emitEvent(TOGGLE_SEARCH, { status: true });
  } else {
    toggleSearchClosed();
  }
};

const headerNav = {
  name: 'headernav',
  inserted: (el, binding) => {
    const { arg, value } = binding;

    switch (arg) {
      case 'burger':
        el.addEventListener('click', () => {
          openMenu(true);
        });
        break;

      case 'paneltoggle':
        el.addEventListener('click', () => {
          togglePanelOpen(el, value ? value.id : undefined);
        });
        break;

      case 'backreturn':
        el.addEventListener('click', () => {
          togglePanelClosed(el, value ? value.id : undefined);
        });
        break;

      case 'menuclose':
        el.addEventListener('click', () => {
          closeMenu();
        });
        el.addEventListener('mouseenter', () => {
          if (window.matchMedia(tabletMediaQuery).matches && value) {
            closeMenu();
          }
        });

        break;

      case 'menuleave':
        el.addEventListener('mouseenter', () => {
          closeMenu();
        });
        break;

      case 'searchtoggle':
        el.addEventListener('click', () => {
          toggleSearchPanel();
        });
        break;

      case 'searchclose':
        el.addEventListener('click', () => {
          toggleSearchClosed();
        });
        break;

      default:
        break;
    }
  },
};
 
let keydownRegistered = false;

const keySubmenuClose = () => {

  if (keydownRegistered) {
    return;
  }
  keydownRegistered = true;

  document.addEventListener('keydown', (event) => {

    const mainMenuButtons = document.querySelector('.vch-header-nav__nav-list.--header-list');
    const activeMenuButton = mainMenuButtons?.querySelector('li.active-one');
    const menuCloseButton = activeMenuButton?.querySelector('button.down-arrow');
    const menuCloseButtonActive = document.activeElement === menuCloseButton;

    const searchButtonEnter = document.querySelector('.vchy-header__search-btn.--open');
    const searchButtonSection = document.querySelector('.vch-header-search.--open');
    const searchButtonEnterBtn = document.getElementById(SEARCH_BTN);

    // Menu Tab loop and click Escape to close the menu
    if(event.key === 'Tab' && activeMenuButton) {
      event.shiftKey ? trapFocusShiftFn(event, activeMenuButton) :  trapFocusFn(event, activeMenuButton);
    }

    if (event.key === 'Escape' && activeMenuButton) {
      const currentActiveFocus = activeMenuButton?.querySelector(
        'button.vch-header-nav__nav-button'
      );
      currentActiveFocus?.focus();
      closeMenu();
    }
    
    if(event.key === 'Enter' && window.matchMedia(tabletMediaQuery).matches && menuCloseButtonActive) {
        const currentActiveFocus = activeMenuButton?.querySelector(
          'button.vch-header-nav__nav-button'
        );
        currentActiveFocus?.focus();
        closeMenu();
    }

    // Search Tab loop and click Escape to close the Search
    if(event.key === 'Tab' && searchButtonEnter) {
      event.shiftKey ? trapFocusShiftFn(event, searchButtonSection) :  trapFocusFn(event, searchButtonSection);
    }

    if (event.key === 'Escape' && searchButtonEnter) {
      searchButtonEnterBtn?.focus();
      toggleSearchClosed();
    }

  });
}

// Trap focus methods
const getFocusableElementsFn = (activeMenuButton) => {
  return Array.from(
    activeMenuButton?.querySelectorAll(
      'a[href], button.down-arrow, input, button.icon-button'
    ) || []
  ).filter(el => el.offsetParent !== null);
}

const trapFocusFn = (event, activeMenuButton) =>  {
  const focusableElements = getFocusableElementsFn(activeMenuButton);
  if (!focusableElements.length) return;

  const first = focusableElements[0];
  const last = focusableElements[focusableElements.length - 1];

  if (!event.shiftKey && document.activeElement === last) {
    event.preventDefault();
    first.focus();
  }
}

const trapFocusShiftFn = (event, activeMenuButton) => {
  const focusableElements = getFocusableElementsFn(activeMenuButton);
  if (!focusableElements.length) return;

  const first = focusableElements[0];
  const last = focusableElements[focusableElements.length - 1];

  if (event.shiftKey && document.activeElement === first) {
    event.preventDefault();
    last.focus();
  }
}


export {
  headerNav,
  emitEvent,
  openMenu,
  deactivatePanels,
  closeMenu,
  togglePanelClosed,
  togglePanelOpen,
  toggleSearchClosed,
  toggleSearchPanel,
  keySubmenuClose,
  getFocusableElementsFn,
  trapFocusFn,
  trapFocusShiftFn
};
